<!--
 * @Description: 外部链接
 * @Autor: wangwangwang
 * @Date: 2021-03-25 10:01:30
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-03-25 10:04:12
-->
<template>
  <div class="pages_content">
    <div class="imgcenter">
      <img src="@/assets/ICPSindex.png" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.imgcenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

